module.exports = __webpack_public_path__ + "img/portfolio_11.f1f28246.jpg";